import { TEST_IDS } from "./TestIds";
import { TRANSLATION_KEYS } from "./TranslationKeys";

import type { CustomerPaymentPreferences } from "../models/CustomerPaymentPreferences";

type ToggleConfig = {
  label: string;
  dataTestId: string;
  field: keyof CustomerPaymentPreferences;
  tooltip?: string;
};

export const PAYMENT_PREFERENCES_TOGGLE_CONFIGS: ToggleConfig[] = [
  {
    label: TRANSLATION_KEYS.onlyUseInstantPaymentSchemes,
    dataTestId: TEST_IDS.getPaymentPreferenceToggleId("instant-only"),
    field: "instantOnly",
  },
  {
    label: TRANSLATION_KEYS.processOnlyInstantPaymentsVerifiedByVolt,
    dataTestId: TEST_IDS.getPaymentPreferenceToggleId(
      "instant-only-volt-verified"
    ),
    field: "verifiedByVoltInstantOnly",
  },
  {
    label: TRANSLATION_KEYS.dynamicBeneficiary,
    dataTestId: TEST_IDS.getPaymentPreferenceToggleId("dynamic-beneficiary"),
    field: "dynamicBeneficiary",
  },
  {
    label: TRANSLATION_KEYS.clearingOptimisation,
    dataTestId: TEST_IDS.getPaymentPreferenceToggleId("clearing-optimisation"),
    field: "highClearingRateBanks",
    tooltip: TRANSLATION_KEYS.clearingOptimisationTooltip,
  },
];
